import { useEffect, useState } from "react";
import { getPublicPhotos } from "../lib/api";

// Simple module-level cache so every card doesn't refetch the same map.
let _cached = null;
let _promise = null;

async function fetchOnce() {
  if (_cached) return _cached;
  if (!_promise) {
    _promise = getPublicPhotos()
      .then((data) => {
        _cached = data || {};
        return _cached;
      })
      .catch(() => {
        _cached = {};
        return _cached;
      });
  }
  return _promise;
}

/**
 * Returns the public URL for a given character slug if the admin has
 * uploaded a photo — otherwise null (caller shows a placeholder).
 */
export default function useCharacterPhoto(slug) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let cancelled = false;
    fetchOnce().then((map) => {
      if (!cancelled) setUrl(map[slug] || null);
    });
    return () => {
      cancelled = true;
    };
  }, [slug]);
  return url;
}

export function invalidateCharacterPhotos() {
  _cached = null;
  _promise = null;
}
